var m = require('mithril');
var Model = require('../../libs/Model');
var formGroup = require('../../components/formGroup');

var pollGroup = Object.create(Model);
pollGroup.name = 'BACnet Poll Group';
pollGroup['@class'] = 'PollGroup';
pollGroup.url = 'bacnetpollgroup';

pollGroup.initForm = function (record) {
  Model.initForm.call(pollGroup, record);
};

pollGroup.fields = {
  parent: {
    default: null,
    hidden: true,
    validators: { presence: false }
  },
  name: {
    default: null,
    validators: {
      presence: true,
      length: { minimum: 3, maximum: 64, default: '' }
    }
  },
  interval: {
    default: 600,
    validators: {
      numericality: { onlyInteger: true, greaterThanOrEqualTo: 0 }
    }
  }
};

pollGroup.view = function () {
  return m('form', { role: 'form' }, [
    pollGroup.errorView(),
    m(formGroup, [
      m('label', { for: 'name-input' }, 'Name'),
      m('input.form-control', {
        id: 'name-input',
        type: 'text',
        onchange: function (ev) { pollGroup.form.name(ev.target.value) },
        value: pollGroup.form.name(),
      })
    ]),
    m(formGroup, [
      m('label', { for: 'interval-input' }, 'Polling Interval (Seconds)'),
      m('input.form-control', {
        id: 'interval-input',
        autocomplete: 'off',
        type: 'number',
        onchange: function (ev) { pollGroup.form.interval(ev.target.value) },
        value: pollGroup.form.interval(),
      })
    ])
  ]);
}

module.exports = pollGroup;

